import { render } from "./CardShare.vue?vue&type=template&id=2a5c825e&scoped=true"
import script from "./CardShare.vue?vue&type=script&lang=js"
export * from "./CardShare.vue?vue&type=script&lang=js"

import "./CardShare.vue?vue&type=style&index=0&id=2a5c825e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5c825e"]])

export default __exports__